exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".contrat-type[data-v-09822408]{width:100%;height:100%}.contrat-type>.body[data-v-09822408]{width:100%;height:100%;display:-ms-flexbox;display:flex;overflow:auto}.contrat-type>.body.save[data-v-09822408]{height:calc(100% - 50px);margin-bottom:15px}.contrat-type>.body>.left[data-v-09822408]{width:calc(100% - 475px);height:100%}.contrat-type>.body>.right[data-v-09822408]{width:460px;height:100%;margin-left:15px}.contrat-type>.footer[data-v-09822408]{display:-ms-flexbox;display:flex;width:100%;height:35px;-ms-flex-pack:end;justify-content:flex-end;display:none}@media screen and (max-width:1199px){.contrat-type>.body>.left[data-v-09822408]{width:calc(100% - 275px)}.contrat-type>.body>.right[data-v-09822408]{width:260px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-09822408","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./src/components/contratType/contratType.scss
// module id = mKUD
// module chunks = 2